export enum NavigationTabId {
  GENERAL_TOOLS = 'general-tools-link',
  REPAIR = 'repair-tools-link',
  RETURN = 'return-tools-link',
  REPAIR_TRACKING = 'repair-tracking-link',
  REORDER_LABELS = 'reorder-labels-link',
  LOST_STOLEN = 'fleet-lost-stolen-link',
  COST_CENTER = 'cost-center-change-link',
  EXCHANGE = 'exchange-tools-link',
  LOAN = 'loan-tools-link',
  PEAK = 'peak-tools-link',
  CIRCULARITY_REPORTS = 'circularity-reports-link'
}

export enum RepairTrackingDetailsTabId {
  REPAIR_TRACKING = 'repair-tracking-details',
  LOAN_TRACKING = 'loan-tracking-details'
}
